'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, memo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import usageTracker from '../../lib/usageTracker';
import { CTA_BOTTOM_BANNER_LINK, LanguageCTALinks } from '../../constants/TrialConstants';
import Logo from '../Logo';
import VideoModal from '../VideoModal';
import chatperson from 'bender-url!../../../img/chat-person.png';
import { parseUtmParams } from '../../util/Urls';

var getLangKey = function getLangKey() {
  return window.I18N_MANUAL_LANG;
};

var FormattedLangMessage = /*#__PURE__*/memo(function () {
  if (window.I18N_MANUAL_LANG !== 'en') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "trialCtaPage.cmsParagraph-alt"
    });
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "trialCtaPage.cmsParagraph"
  });
});

var TrialCtaPage = function TrialCtaPage(_ref) {
  var websiteUrl = _ref.websiteUrl;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showVideo = _useState2[0],
      setShowVideo = _useState2[1];

  var lang = getLangKey();
  var showLanguageAlt = lang !== 'en';
  var parsedUtmParams = parseUtmParams();

  var handleClick = function handleClick() {
    usageTracker.log('trialBannerClick', {
      type: 'dtt-cta-click',
      websiteUrl: websiteUrl,
      source: 'trial-cta-footer'
    });
  };

  var onShowVideoModal = function onShowVideoModal() {
    setShowVideo(!showVideo);
  };

  return /*#__PURE__*/_jsx("div", {
    className: "trial-cta-page",
    "data-reagan-selector": "trial-cta-page",
    children: /*#__PURE__*/_jsxs("div", {
      className: "wsg-container trial-cta-container",
      children: [showVideo && /*#__PURE__*/_jsx(VideoModal, {
        handleClose: onShowVideoModal,
        ctaLink: CTA_BOTTOM_BANNER_LINK + "&" + parsedUtmParams
      }), /*#__PURE__*/_jsxs("div", {
        className: "cta-container",
        children: [/*#__PURE__*/_jsx("div", {
          className: "cta-image-left",
          children: /*#__PURE__*/_jsx("img", {
            src: chatperson
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "cta-info-right",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "trial-cta-header",
            children: [/*#__PURE__*/_jsx("div", {
              className: "product-logo",
              children: /*#__PURE__*/_jsx(Logo, {})
            }), /*#__PURE__*/_jsx("div", {
              className: "header",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                className: "header",
                message: "trialCtaPage.header"
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "paragraph",
            children: /*#__PURE__*/_jsx(FormattedLangMessage, {})
          }), showLanguageAlt ? /*#__PURE__*/_jsx("div", {
            className: "trial-cta-button",
            children: /*#__PURE__*/_jsx("a", {
              className: "button white",
              href: LanguageCTALinks[lang] + "&" + parsedUtmParams,
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: 'trialBanner.ctaButtonGetGuide'
              })
            })
          }) : /*#__PURE__*/_jsxs("div", {
            className: "trial-cta-button",
            children: [/*#__PURE__*/_jsx("a", {
              className: "button secondary-ghost",
              onClick: onShowVideoModal,
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "trialBanner.ctaButtonWatchVideo"
              })
            }), /*#__PURE__*/_jsx("a", {
              className: "button white",
              onClick: handleClick,
              href: CTA_BOTTOM_BANNER_LINK + "&" + parsedUtmParams,
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "trialBanner.ctaButtonCourse"
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "microcopy",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "trialCtaPage.microcopy"
            })
          })]
        })]
      })]
    })
  });
};

TrialCtaPage.propTypes = {
  websiteUrl: PropTypes.string.isRequired
};
export default TrialCtaPage;